import { PromptApi } from '../../../apis/promptManagementApi';

export class PromptResponse {
  chatData: string;
  promptApi: PromptApi;
  profEmail: string;
  accessToken: string;
  loading: boolean = false;
  useAIServiceStream = false;
  id: string;
  promptid: string;
  consolidatedMessage: string = '';

  constructor(
    promptApi: PromptApi,
    profEmail: string,
    accessToken: string,
    id = '',
    promptid = '',
  ) {
    this.chatData = '';
    this.accessToken = accessToken;
    this.profEmail = profEmail;
    this.promptApi = promptApi;
    this.id = id;
    this.promptid = promptid;
  }

  async getResponse(
    message: any[],
    _onStart?: Function | null,
    _onStop?: Function | null,
    _onData?: Function | null,
    _onError?: Function | null,
  ) {
    if (!this.loading) {
      this.loading = true;
      const msg = message;
      const args: any = {
        message: msg,
        emailid: this.profEmail,
      };
      if (this.useAIServiceStream) {
        args['promptid'] = this.promptid;
        args['id'] = this.id;
      }
      await this.promptApi[
        this.useAIServiceStream ? 'aiServiceStream' : 'claudeAIServiceStream'
      ](
        args,
        this.accessToken,
        () => {
          this.chatData = '';
          this.consolidatedMessage = '';
          if (_onStart) {
            _onStart();
          }
        },
        () => {
          this.loading = false;
          if (_onStop) {
            _onStop();
          }
        },
        (data: any) => {
          try {
            if (
              !data ||
              data === '[DONE]' ||
              data === '\n' ||
              this.useAIServiceStream
                ? data === '\n'
                : JSON.parse(data).text === '\n'
            ) {
              this.postMessage(this.chatData + '\n');
              this.consolidatedMessage += this.chatData + '\n';
              this.chatData = '';
            } else {
              this.chatData += this.useAIServiceStream
                ? data
                : JSON.parse(data).text;
            }
          } catch (e) {
            this.postMessage(this.chatData + '\n');
            this.consolidatedMessage += this.chatData + '\n';
            this.chatData = '';
          } finally {
            if (this.chatData) {
              this.postMessage(this.chatData);
              this.consolidatedMessage += this.chatData;
              this.chatData = '';
            }
          }
          if (_onData) {
            _onData(data);
          }
        },
        () => {
          this.loading = false;
          if (_onError) {
            _onError();
          }
        },
      );
    }
  }
  postMessage = (message: any) => {};
}
